import React from "react";
import { useTranslation } from "react-i18next";

type BrandLogoProps = {
  className?: string;
  inverted?: boolean;
};

export function BrandLogo({ className = "", inverted = false }: BrandLogoProps) {
  const { t } = useTranslation();

  const nameClass = inverted
    ? "text-white"
    : "text-canvas-950";
  const descriptorClass = inverted
    ? "text-canvas-300"
    : "text-canvas-500";

  return (
    <span className={`inline-flex flex-col leading-none ${className}`}>
      <span
        className={`font-brand text-[1.35rem] font-semibold tracking-tight sm:text-[1.55rem] ${nameClass}`}
      >
        {t("common.siteName")}
      </span>
      <span
        className={`mt-1 font-sans text-[0.62rem] font-medium tracking-[0.28em] uppercase sm:text-[0.68rem] ${descriptorClass}`}
      >
        {t("common.siteDescriptor")}
      </span>
    </span>
  );
}
